<template>
  <Menu
    as="div"
    class="relative text-right inline-block"
  >
    <div>
      <MenuButton
        class="inline-flex justify-center w-full rounded-full border border-gray-400 shadow-sm px-3 py-1 bg-gray-100 text-sm font-medium text-blue-600 hover:bg-gray-300"
      >
        {{ selectedDisplay }}
        <ChevronDownIcon
          class="-mr-1 ml-2 h-5 w-5"
          aria-hidden="true"
        />
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <MenuItems
        class="justify-end origin-top-right absolute right-0 mt-2 w-32 rounded-md shadow-lg bg-gray-100 divide-y divide-gray-400 focus:outline-none z-50"
      >
        <div class="py-1">
          <MenuItem v-slot="{ active }">
            <a
              @click.prevent="select(true)"
              href="#"
              :class="[
                active ? 'bg-gray-400 text-gray-900' : 'text-gray-700',
                'group flex items-center px-4 py-2 text-sm hover:bg-blue-600 hover:text-gray-100'
              ]"
            >
              Publish
            </a>
          </MenuItem>
          <MenuItem v-slot="{ active }">
            <a
              @click.prevent="select(false)"
              href="#"
              :class="[
                active ? 'bg-gray-400 text-gray-900' : 'text-gray-700',
                'group flex items-center px-4 py-2 text-sm hover:bg-blue-600 hover:text-gray-100'
              ]"
            >
              Draft
            </a>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import { ref } from 'vue'
import { ChevronDownIcon } from '@heroicons/vue/solid'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

export default {
  props: {
    modelValue: {
      type: Boolean
    },
    publishRoute: {
      type: String,
      default: null
    },
    unpublishRoute: {
      type: String,
      default: null
    },
    form: {
      type: Object,
      default() {
        return null
      }
    }
  },

  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ChevronDownIcon
  },

  data() {
    return {
      selected: null,
      actionForm: this.form || this.$inertia.form({})
    }
  },

  created() {
    this.selected = this.modelValue
  },

  watch: {
    modelValue(newVal, oldVal) {
      this.selected = this.modelValue
    }
  },

  computed: {
    selectedDisplay() {
      if (this.selected) {
        return 'Published'
      }

      return 'Drafted'
    }
  },

  methods: {
    select(value) {
      if (value === this.selected) {
        return
      }

      this.selected = value
      this.submit()
    },
    submit() {
      if (this.selected) {
        this.publish()
      } else {
        this.unpublish()
      }
    },
    publish() {
      this.actionForm.post(this.publishRoute, {
        onFinish: () => {
          this.triggerSelected(true)
        }
      })
    },
    unpublish() {
      this.actionForm.post(this.unpublishRoute, {
        onFinish: () => {
          this.triggerSelected(false)
        }
      })
    },
    triggerSelected(value) {
      this.$emit('update:modelValue', value)
    }
  }
}
</script>
